import React, { useRef, useEffect } from 'react';
export default function OpenData({ type, openid, children }) {
  const ref = useRef(null);
  useEffect(() => {
    window.WWOpenData && WWOpenData.bind(ref.current);
  });
  if (children == '不限') return children;
  if (window.WWOpenData && openid) {
    return <ww-open-data ref={ref} type={type} openid={openid} />;
  } else {
    return children || null;
  }
}
